<template>
  <div class="product-grid containerV2" :class="classes">
    <template v-for="(product, index) in products" :key="product.id">
      <ProductCardHelper
        v-if="!product.skeleton"
        v-slot="{ primaryMedia, secondaryMedia }"
        :product="product"
        :image-type="getImageType(index)"
      >
        <ProductCard
          :product="product"
          class="product-card"
          :media="primaryMedia"
          :hover-media="secondaryMedia"
        />
      </ProductCardHelper>
      <SkeletonProductCard v-else />
    </template>
    <PromotionBanner
      v-if="promotionBanner"
      :title="promotionBanner.title"
      :button-text="promotionBanner.buttonText"
      :description="promotionBanner.description"
      :vertical-align="promotionBanner.verticalAlign"
      :external="promotionBanner.external"
      class="promotion-banner"
      :class="{
        'promotion-banner--portrait':
          promotionBanner.orientation === 'portrait',
      }"
      :images="promotionBanner.images"
      :orientation="promotionBanner.orientation"
    />
  </div>
</template>

<script>
import ProductCard from "@/components/ProductCard.vue";
import ProductCardHelper from "@/components/product-card/ProductCardHelper.vue";
import SkeletonProductCard from "@/components/skeleton/SkeletonProductCard.vue";
import PromotionBanner from "@/components/collection/PromotionBanner.vue";

import { mapState } from "vuex";
import { collectionImageSequence } from "@/helpers/imageSequences.js";
import promotionBannerContent from "@/assets/json/collection/PromotionBanner.json";

export default {
  name: "ProductGrid",
  components: {
    ProductCard,
    ProductCardHelper,
    PromotionBanner,
    SkeletonProductCard,
  },
  props: {
    narrow: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      promotionBannerContent,
    };
  },
  computed: {
    ...mapState("collection", ["collection", "loading"]),
    classes() {
      return {
        "product-grid--narrow": this.narrow,
      };
    },
    promotionBanner() {
      return this.promotionBannerContent[this.collection?.handle];
    },
  },
  methods: {
    getImageType(index) {
      const collectionSpecificImageSequence =
        this.collection?.imageSequence?.value.replaceAll(" ", "").split(",") ||
        null;

      const imageSequence =
        collectionSpecificImageSequence || collectionImageSequence;

      return imageSequence[index % imageSequence.length];
    },
  },
};
</script>

<style lang="scss" scoped>
.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 10px;
  row-gap: 40px;

  @include respond-above(md) {
    column-gap: 20px;
  }

  @include respond-above(lg) {
    grid-template-columns: repeat(4, 1fr);
  }

  &.product-grid--narrow {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    row-gap: 40px;
    padding: 0;
  }
}

.promotion-banner {
  grid-column: 1 / 3;
  grid-row: 2;

  &--portrait {
    grid-column: 1 / 2;
  }
}

.product-card--oversized {
  grid-column-start: span 2;
  grid-row-start: span 2;

  :deep(.media-wrapper) {
    aspect-ratio: auto;
    padding-top: 135%;
    position: relative;

    .media {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}
</style>
